import { guid } from '../../../../../utils/guid'
import SYSTEM_DATA from '../../../../../data'
import translator from '../../../../../translate'
import {
  FormItemType,
  FormItemFilterAddMode,
} from '../../../../../form/props/form-item/default'

const FormItemInvited = {
  id: guid().uid(),
  attribute: 'IsInvited',
  label: translator._('general.invited'),
  type: FormItemType.MENU,
  optionAttributeName: { label: 'label', value: 'value' },
  required: false,
  disabled: false,
  hidden: false,
  filterAddMode: FormItemFilterAddMode.SINGLE,
  options: () => {
    return SYSTEM_DATA.FILTER_OPTIONS.IsInvited
  },
}

export default FormItemInvited
